module.exports = __webpack_public_path__ + "static/media/1002.b0b589a5.png";